import { LinkButton, PublicButton } from '@yes.technology/react-toolkit'
import { getPublicButtonRest, isPublicButton } from 'shared/utils'
import { ArticleButton as ArticleButtonType } from 'site/Renderer/components/ArticleContainer/ArticleContainer.types'

export type ArticleButtonProps = {
  buttonConfig: ArticleButtonType
}

const ArticleButton = ({ buttonConfig }: ArticleButtonProps) => {
  if (isPublicButton(buttonConfig)) {
    return (
      <PublicButton
        href={buttonConfig?.link?.url ?? buttonConfig?.href}
        target={buttonConfig?.link?.target ?? buttonConfig?.target ?? '_self'}
        style={buttonConfig?.style}
        {...getPublicButtonRest(buttonConfig)}
      >
        {buttonConfig?.label}
      </PublicButton>
    )
  }

  return (
    <LinkButton
      href={buttonConfig?.href}
      target={buttonConfig?.target ?? '_self'}
      rel={
        buttonConfig?.target === '_blank' ? 'noopener noreferrer' : undefined
      }
      variant='secondary'
      style={buttonConfig?.style}
    >
      {buttonConfig?.label}
    </LinkButton>
  )
}

export default ArticleButton
